<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovetoken/_update/updateManage.vue'
export default {
  components: {
    createContent
  }
}
</script>
